import { IVMessageBox } from '@apps/vhq/src/app/common/interfaces/message-box/IVMessageBox';

export enum messageBoxType {
  CONFIRMATION = 'CONFIRMATION',
  CUSTOM = 'CUSTOM',
  ERROR = 'ERROR',
  INFORMATION = 'INFORMATION',
  SUCCESS = 'SUCCESS',
  VALIDATION = 'VALIDATION',
  WARNING = 'WARNING',
}

export enum messageBoxTitle {
  CONFIRMATION = 'Confirmation',
  ERROR = 'Error',
  INFORMATION = 'Information',
  SUCCESS = 'Success',
  VALIDATION = 'Validation',
  WARNING = 'Warning',
}

export enum messageBoxAction {
  AFFIRMATIVE,
  DECLINE,
  CANCEL,
  CLOSE,
}

export const messageBoxButtonsConfig: IVMessageBox[] = [
  {
    type: messageBoxType.CONFIRMATION,
    title: messageBoxTitle.CONFIRMATION,
    affirmationButton: {
      isVisible: true,
      title: 'Yes',
      style: 'is-primary',
    },
    declineButton: {
      isVisible: true,
      title: 'No',
      style: 'is-primary',
    },
    cancelButton: {
      isVisible: false,
    },
  },
  {
    type: messageBoxType.CUSTOM,
    title: 'Message',
    affirmationButton: {
      isVisible: true,
      title: 'Yes',
      style: 'is-primary',
    },
    declineButton: {
      isVisible: true,
      title: 'No',
      style: 'is-danger',
    },
    cancelButton: {
      isVisible: true,
    },
  },
  {
    type: messageBoxType.ERROR,
    title: messageBoxTitle.ERROR,
    affirmationButton: {
      isVisible: true,
      title: 'OK',
      style: 'is-danger',
    },
    declineButton: {
      isVisible: false,
    },
    cancelButton: {
      isVisible: false,
    },
  },
  {
    type: messageBoxType.INFORMATION,
    title: messageBoxTitle.INFORMATION,
    affirmationButton: {
      isVisible: true,
      title: 'Acknowledgement',
      style: 'is-primary',
    },
    declineButton: {
      isVisible: false,
    },
    cancelButton: {
      isVisible: false,
    },
  },
  {
    type: messageBoxType.SUCCESS,
    title: messageBoxTitle.SUCCESS,
    affirmationButton: {
      isVisible: true,
      title: 'OK',
      style: 'is-primary',
    },
    declineButton: {
      isVisible: false,
    },
    cancelButton: {
      isVisible: false,
    },
  },
  {
    type: messageBoxType.WARNING,
    title: messageBoxTitle.WARNING,
    affirmationButton: {
      isVisible: true,
      title: 'Yes',
      style: 'is-danger',
    },
    declineButton: {
      isVisible: true,
      title: 'No',
      style: 'is-primary',
    },
    cancelButton: {
      isVisible: false,
    },
  },
  {
    type: messageBoxType.VALIDATION,
    title: messageBoxTitle.VALIDATION,
    affirmationButton: {
      isVisible: true,
      title: 'OK',
      style: 'is-primary',
    },
    declineButton: {
      isVisible: false,
    },
    cancelButton: {
      isVisible: false,
    },
  },
];
